import { createFileRoute } from '@tanstack/react-router';
import { useClientCtx } from '../../../../features/B4/ClientLayout';
import { SimulationTab } from '../../../../features/C3/Simulation';

/** Client page "הדמיה" tab (lane C3). The site of a multi-site client comes from the layout's ?site=. */
export const Route = createFileRoute('/_app/client/$clientId/simulation')({
  component: SimulationRoute,
});

function SimulationRoute() {
  const ctx = useClientCtx();
  return <SimulationTab client={ctx.client} siteId={ctx.siteId} />;
}
